export const BUTTON_LABEL: Record<string, string> = {
  up: 'Up',
  down: 'Down',
  right: 'Right',
  left: 'Left',
  back: 'Back',
  select: 'Select',
};
